import { gpActions } from '../const/gp-actions.const';
import { currentMainState } from '../game-plan.state';

export function createActionLanes(): void {
    const state = currentMainState();

    state.actionLanes = [];
    gpActions.forEach((value, key) => {
        state.actionLanes.push({
            actionType: key,
            action: value,
            rows: null,
        });
    });
}
